export var HTTP_ROUTE_PRIVATE = Symbol('hTTPRoute-private');
//# sourceMappingURL=privates.js.map